import type {
  MediaType
} from 'be-structures/typescript-generator/assembly'

export const MEDIA_TYPES: MediaType[] = ['FAX', 'HOME_PHONE', 'MAIL', 'MOBILE_PHONE', 'PHONE']